<template>
    <!-- 企业微信 在线客服 -->
    <figure class="serviceWrap">
        <!-- 弹窗内容 -->
        <div class="serviceContent" :class="{ showContent: serviceStatus }">
            <div class="imgWrap">
                <!-- <img src="../../assets/img/EnterpriseWeChat.jpg" alt=""> -->
                <el-image style="width: 130px; height: 130px" :src="imageSrc" :preview-src-list="srcList">
                </el-image>
            </div>

            <span>微信扫码咨询客服</span>
        </div>
        <div class="serviceLabel" @click="toggleService">
            <p class="labelText">在线客服</p>
            <p class="oprationBtn icon iconfont icon-you" :class="{ roteEnd: serviceStatus }"></p>
        </div>
    </figure>
</template>

<script>
export default {
    props: {},
    data() {
        return {
            imageSrc: require('@/assets/img/EnterpriseWeChat.jpg'),
            srcList: [],//预览图片数组
            serviceStatus: true,//弹窗展示状态 默认true
        }
    },
    created() {
        this.srcList = [this.imageSrc];
    },
    methods: {
        // 展开 / 收起 弹窗模块
        toggleService() {
            this.serviceStatus = !this.serviceStatus;
        }
    }
}
</script>

<style scoped src="./index.css"></style>